
import { AUDIENCES_ENTER_FILTER, AUDIENCES_SETUP_BEGIN, AUDIENCES_SETUP_UPDATE } from 'actions'

const initialState = {
  filter: ''
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case AUDIENCES_ENTER_FILTER:
      return {
        ...state,
        filter: payload
      }
    case AUDIENCES_SETUP_BEGIN:
      return {
        ...state,
        setupPage: 'sql',
        setupData: payload
      }
    case AUDIENCES_SETUP_UPDATE:
      return {
        ...state,
        setupPage: payload.page,
        setupData: {
          ...state.setupData,
          ...payload.data
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/audiences.js